<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md4>
        <material-card color="green" title="Formulation" text="Details">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    class="purple-input"
                    label="Formulation Id"
                    v-model="input.formulationId"
                    :disabled="!newFormulation"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    label="Fragrance Desc"
                    v-model="input.fragranceDesc"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex>
                  <v-select :items="solutions" v-model="input.solutionType"></v-select>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    label="Percentage (0 to 100)"
                    v-model="input.percentage"
                    class="purple-input"
                  />
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field label="Runtime (ms)" v-model="input.runtime" class="purple-input" />
                </v-flex>

                <v-flex xs12>
                  <p>{{errorMsg}}</p>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-2 font-weight-light"
                    color="success"
                    v-bind:disabled="loading"
                    v-on:click="saveFormulation()"
                  >Save</v-btn>

                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    v-bind:disabled="loading"
                    v-on:click="deleteFormulation()"
                  >Delete</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md4></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default

export default {
  data() {
    return {
      input: {
        formulationId: "",
        fragranceDesc: "",
        solutionType: "",
        solutionName: "",
        percentage: 0,
        runtime: 0
      },
      solutions: [],
      loading: false,
      errorMsg: "",
      newFormulation: false
    }
  },

  async mounted() {
    middleware.run(this.$router)
    await this.init()
  },
  methods: {
    async init() {
      this.loading = true

      try {
        if (this.$route.params.id == 0) {
          //if formulation route is id 0, we are creating a new formulation
          this.newFormulation = true
        } else {
          //retrieve formulation by id
          this.input.formulationId = this.$route.params.id
          var result = await restHelper.getFormulation(this.input.formulationId)
          var formulation = result.data
          this.input.fragranceDesc = formulation.fragranceDesc
          this.input.solutionType = formulation.solutionType
          this.input.percentage = formulation.percentage
          this.input.runtime = formulation.runtime
        }

        result = await restHelper.getSolutions()
        this.solutions = result.data.solutions
      } catch (error) {}

      this.loading = false
    },

    async saveFormulation() {
      this.loading = true

      try {
        if (this.newFormulation) {
          //create new formulation
          await restHelper.createFormulation({
            id: parseInt(this.input.formulationId),
            fragranceDesc: this.input.fragranceDesc,
            solutionType: this.input.solutionType,
            percentage: parseFloat(this.input.percentage),
            runtime: parseInt(this.input.runtime)
          })
        } else {
          //update existing formulation
          await restHelper.updateFormulation(this.input.formulationId, {
            fragranceDesc: this.input.fragranceDesc,
            solutionType: this.input.solutionType,
            percentage: parseFloat(this.input.percentage),
            runtime: parseInt(this.input.runtime)
          })
        }

        this.$router.push("/formulations")
      } catch (error) {
        this.errorMsg = "Error while saving formulation"
      }

      this.loading = false
    },

    async deleteFormulation() {
      if (confirm("Are you sure?")) {
        //delete formulation
        this.loading = true
        try {
          await restHelper.deleteFormulation(this.input.formulationId)
          this.$router.push("/formulations")
        } catch (error) {
          this.errorMsg = "Error while deleting formulation"
        }

        this.loading = false
      }
    }
  }
}
</script>

